<template>
  <div class="mfa-content">
    <Heading class="mfa-content__title" :level="4" data-testid="mfa-title-push">
      Código enviado por notificação
    </Heading>
    <BaseText
      :color="NebraskaColors.textSecondary"
      data-testid="mfa-description-push"
    >
      1. Acesse <strong>Configurações</strong> do dispositivo <br />
      2. Clique em <strong>Notificações</strong> e dê permissão ao aplicativo da
      Warren <br />
      3. Se você não recebeu, clique em Reenviar
    </BaseText>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { BaseText } from '@/components/base-text';
import { Heading } from '@/components/heading';

@Component({
  name: 'MFAContentPush',
  components: { BaseText, Heading }
})
export default class MFAContentPush extends Vue {
  readonly NebraskaColors = NebraskaColors;
}
</script>

<style lang="less" scoped>
.mfa-content {
  max-width: 370px;

  &__title {
    margin-bottom: @size-spacing-x400;
  }
}
</style>
